import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import PointModal from "./PointModal";
import { deleteAction, getAction, httpAction } from '@api/manage';
import newMap from '@/components/Map/newMap.vue';
/*table 模板点位表头*/

var columns = [{
  title: '序号',
  dataIndex: '',
  key: 'rowIndex',
  width: 10,
  align: 'center',
  customRender: function customRender(t, r, index) {
    return parseInt(index) + 1;
  }
}, {
  title: '巡检点名称',
  align: 'left',
  width: '50%',
  dataIndex: 'name'
  /*customRender: (text, record, index) => {		//在此处定义
    if (record.status == 0) {
      return { style: { 'color': '#cc0000' } }    //return 想要设置的样式
    }
  }*/

}, {
  title: '操作',
  dataIndex: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center',
  width: '30%'
}];
export default {
  name: 'InspectionTemplateModal',
  mixins: [ModalFormMixin],
  components: {
    PointModal: PointModal,
    // 添加子项
    newMap: newMap
  },
  data: function data() {
    return {
      /* 排序参数 */
      columns: columns,
      // 模板点位表头信息
      paneChange: '1',
      idItem: '0',
      showTab: false,
      hiddenButton: true,
      // 切换反馈面板时，隐藏确定取消按钮
      dataSrouce: [],
      title: '巡检模板表单',
      tableName: 'om_inspection_template',
      form_fields: ['code', 'name', 'category', 'isGps', 'coordinate', 'remark', 'delFlag', 'status', 'sort'],
      form_fields_time: [],

      /*地图开始*/
      pointCoordinate: [],
      // 模板点位坐标集
      selectType: 1,
      visible: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      mapPointList: [],

      /*地图结束*/
      url: {
        delete: '/om/inspection/template/point',
        deleteItem: '/om/inspection/point/item',
        add: '/om/inspection/template',
        edit: '/om/inspection/template',
        tree: '/om/inspection/template/tree/'
      },
      validatorRules: {
        name: {
          rules: [{
            required: true,
            message: '请输入模板名称!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入模板类型!'
          }]
        },
        isGps: {
          rules: [{
            required: true,
            message: '请选择是否启用巡检轨迹!'
          }]
        },
        delFlag: {
          rules: [{
            required: false,
            message: '请输入删除状态!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择模板状态!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    coordinateOk: function coordinateOk(value) {
      var that = this;

      if (value != null) {
        var a = '';
        value.forEach(function (element, index) {
          var b = '';
          element.forEach(function (item, i) {
            b += i == element.length - 1 ? item.join(',') : item.join(',') + '-';
          });
          a += index == value.length - 1 ? b : b + ':';
        }); // console.log(a, '抽屉2')

        that.form.setFieldsValue({
          coordinate: value ? a : null
        });
        that.model.coordinate = value ? a : null;
      }
    },
    coordinateChange: function coordinateChange() {
      // console.log(this.model.coordinate)
      this.$refs.mapLine.show(this.model.coordinate);
    },

    /*
     * 行渲染 暂时不可用 todo*/
    tableRowClass: function tableRowClass(record, index) {
      if (record.status > 1) {
        return 'red';
      } else {
        return '';
      }
    },
    modalFormOk: function modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadPointsTree(this.model.id);
    },

    /**
     * 添加一级巡检
     */
    addFirstMenu: function addFirstMenu(record) {
      var that = this;
      this.$refs.modalForm.edit({
        pid: 0,
        templateId: that.model.id,
        templateName: that.model.name,
        status: that.model.status,
        rowSize: 0,
        parentName: '',
        coordinate: ''
      });
      this.$refs.modalForm.title = '新增：' + '一级巡检点';
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    // 切换面板时重载
    handleTabChange: function handleTabChange(key) {
      this.line = []; //console.log(this.$refs.line)

      this.paneChange = key;

      if (key == '1') {
        this.hiddenButton = true; // 展示本页面确定取消
      }

      if (key == '2') {
        var that = this;
        that.hiddenButton = true; // 展示本页面确定取消
        // 只展示预设点位坐标 图标

        if (this.model.coordinate) {
          // 解开可看到每分钟12次获取的真实数据

          /*that.show(this.model.routes, pointcoordinateItem)*/
          that.show(this.model.coordinate, this.pointcoordinate);
        } else {
          that.show('', this.pointcoordinate);
        }
      }

      if (key == '3') {
        this.hiddenButton = false; // 隐藏本页面确定取消
      }
    },

    /*
     * 自动获取自增id*/
    queryLastId: function queryLastId() {
      var _this = this;

      var params = {};
      getAction('/om/inspection/template/getLastId', params).then(function (res) {
        if (res.success) {
          _this.idItem = res.result;

          if (_this.idItem == 0) {
            _this.idItem = 1;
          }

          _this.form.setFieldsValue({
            code: 'TPL' + moment().format('YYMMDD') + '00' + _this.idItem
          });
        } else {
          console.log(res.message);
        }
      });
    },
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this2 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (record.id != null) {
        this.loadPointsTree(this.model.id);
      } else this.queryLastId();

      this.$nextTick(function () {
        var that = _this2;
        that.form.setFieldsValue(pick(that.model, that.form_fields));

        _this2.form.setFieldsValue({
          status: '1'
        });

        _this2.form.setFieldsValue({
          isGps: '1'
        }); //时间格式化


        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    close: function close() {
      this.line = []; //this.$refs.newMap.pipePositionList = []
      //this.$refs.newMap.ontoClear()

      this.$emit('close');
      this.visible = false;
      this.paneChange = '1';
    },
    handleOk: function handleOk() {
      var that = this;

      if (this.model.id) {
        if (!this.mapPointList || this.mapPointList.length == 0) {
          this.showTab = true;
          this.visible = true;
          this.paneChange = '2';
          this.$message_custom('巡检轨迹不能为空', 'error');
          return;
        }
      }

      this.$emit('mapChange', this.mapPointList); // 触发表单验证

      that.form.validateFields(function (err, values) {
        that.coordinateOk(that.mapPointList);

        if (!err) {
          that.confirmLoading = true;
          values.coordinate = that.model.coordinate ? that.model.coordinate : null;
          var formData = Object.assign(that.model, values); // 默认未删除

          formData.delFlag = 0; //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          }); //console.log(formData)

          var httpurl = '',
              method = '';

          if (!that.model.id) {
            httpurl = that.url.add ? that.url.add : that.pagePath;
            method = 'post';
          } else {
            httpurl = that.url.edit ? that.url.edit : that.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },

    /**
     * 查看: 巡检点详情
     */
    handleDetail: function handleDetail(record) {
      /*巡检反馈单===需求中的巡检记录*/
      this.$refs.modalForm.title = '巡检点详情';
      this.$refs.modalForm.disableSubmit = true;
      record.templateName = this.model.name;
      this.$refs.modalForm.edit(record);
    },

    /**
     * 添加子巡检点
     */
    handleAddItems: function handleAddItems(record) {
      this.$refs.modalForm.title = '添加子巡检点';
      this.$refs.modalForm.disableSubmit = false;
      var that = this;
      this.$refs.modalForm.edit({
        templateName: that.model.name,
        templateId: that.model.id,
        status: that.model.status,
        pid: record.key,
        parentName: record.name
      });
    },

    /**
     * 编辑:巡检点
     */
    handlePointEdit: function handlePointEdit(record) {
      this.$refs.modalForm.title = '编辑：巡检点';
      this.$refs.modalForm.disableSubmit = false;
      record.templateName = this.model.name; //record.status = this.model.status

      this.$refs.modalForm.edit(record);
    },

    /**
     * 删除:巡检点
     */
    handlePointDelete: function handlePointDelete(id) {
      var that = this;
      deleteAction(that.url && that.url.delete ? that.url.delete : this.pagePath, {
        id: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadPointsTree(that.model.id);
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },

    /**
     * 获取巡检模板站点树
     */
    loadPointsTree: function loadPointsTree(params) {
      var that = this;
      /* 数据源制空*/

      that.pointcoordinate = [];
      that.dataSrouce = [];
      getAction(that.url.tree + params).then(function (res) {
        if (res.success) {
          that.dataSrouce = res.result;
        }
        /* 取出点位坐标缓存在pointcoordinate坐标集中*/


        that.dataSrouce.forEach(function (tree) {
          if (tree.coordinate) {
            that.pointcoordinate.push(tree.coordinate);
          }
        });
      });
    },

    /*地图开始*/
    // 地图画线功能点击确定后的回调
    labelPosition: function labelPosition(value) {
      this.mapPointList = value;
      this.coordinateOk(this.mapPointList);
    },
    show: function show(parmCenter) {
      var _this3 = this;

      this.line = [];

      if (parmCenter) {
        var pointList = parmCenter.split(':');
        this.line = pointList.map(function (v) {
          return v.split('-').map(function (item) {
            return item.split(',');
          });
        });
      }

      console.log(this.line, '回显');
      this.mapPointList = _toConsumableArray(this.line);
      this.selectType = 1;
      this.visible = true;
      this.$nextTick(function () {
        _this3.$refs.newMap.pipePositionList = _this3.line;
      });
    }
    /*地图结束*/

  }
};